<template>
  <div class="dark:bg-transparent-black-400 rounded-b-lg py-16 grow">
    <div
      v-if="card?.Url && card?.CTAText"
      class="mt-[-42px] mb-16 flex flex-row items-center justify-center"
    >
      <AppButton
        aria-hidden="true"
        tabindex="-1"
        color="seasonaldeals"
        class="group"
        shadow="softWider"
        no-border
      >
        <div class="flex flex-row items-center">
          <span
            class="heading-xxs text-text-on-highlight group-hover:text-text-on-action-hover"
          >
            {{ card.CTAText }}
          </span>
          <nuxt-icon
            :filled="false"
            name="chevron-right"
            class="hidden sm:block md:hidden lg:block ml-12 mr-[-10px] text-32-32 group-hover:text-text-on-action-hover"
          />
        </div>
      </AppButton>
    </div>
    <div class="px-0 md:px-8">
      <ul class="list-disc ml-24 p-0">
        <li
          v-for="bulletPoint in bulletPoints"
          :key="bulletPoint"
          class="marker:text-text-primary"
        >
          <p>{{ bulletPoint }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SeasonDealMarkupCard } from '~/models/seasonaldeals/SeasonalDealMarkupCard.model';

interface Props {
  card: SeasonDealMarkupCard;
  isFamilyCard: boolean;
}

const props = defineProps<Props>();

const familyCardPoints: string[] = [
  '12 mån bindning',
  'Alla kan vara familj',
  '5G ingår',
  'Alla får sin egen surf',
];

const otherCardsPoints: string[] = [
  '12 mån bindning',
  '5G ingår',
  'Alltid fria samtal & sms inom EU/EES',
];

const bulletPoints = computed(() => {
  if (props.isFamilyCard === true) {
    return familyCardPoints;
  }

  return otherCardsPoints;
});
</script>
